// src/hooks/usePageContent.js
import { useState } from "react";
import {
    getActiveShipment,
    getActiveShipmentDetail,
    getSingleShipment,
    setPrimaryAddress
} from "../services/shipmentService";

const useShipment = () => {
    const [status, setStatus] = useState("idle"); // idle | loading | done | error
    const [addStatus, setAddStatus] = useState("idle");
    const [removeStatus, setRemoveStatus] = useState("idle");
    const [setPrimaryStatus, setSetPrimaryStatus] = useState("idle");
    const [error, setError] = useState("");
    const [data, setData] = useState([]);
    const [single, setSingle] = useState(null);

    const fetchActiveShipment = async () => {
        setStatus("loading");
        setError("");

        try {
            const response = await getActiveShipment();

            if (response?.status !== "Error") {
                setData(response.data ?? response); // depending on API shape
                setStatus("done");
            } else {
                setStatus("error");
                setError(response?.message || "Something went wrong");
            }
        } catch (err) {
            setStatus("error");
            setError(err?.message || "Something went wrong");
        }
    };

    const fetchActiveShipmentDetail = async (shipmentId) => {
        setStatus("loading");
        setError("");

        try {
            const response = await getActiveShipmentDetail(shipmentId);

            if (response?.status !== "Error") {
                setData(response.data ?? response); // depending on API shape
                setStatus("done");
            } else {
                setStatus("error");
                setError(response?.message || "Something went wrong");
            }
        } catch (err) {
            setStatus("error");
            setError(err?.message || "Something went wrong");
        }
    };

    const fetchSingleShipment = async (shipmentId) => {
        setStatus("loading");
        setError("");

        try {
            const response = await getSingleShipment(shipmentId);

            if (response?.status !== "Error") {
                setSingle(response.data ?? response); // depending on API shape
                setStatus("done");
            } else {
                setStatus("error");
                setError(response?.message || "Something went wrong");
            }
        } catch (err) {
            setStatus("error");
            setError(err?.message || "Something went wrong");
        }
    };

    const setPrimary = async (addressId) => {
        setSetPrimaryStatus("loading");
        setError("");
        // cart item
        // "productId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        // "variantCombinationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        // "applicationUserId": "string",
        // "qty": 0
        try {
            const response = await setPrimaryAddress(addressId);

            if (response?.status !== "Error") {
                setSetPrimaryStatus("done");
            } else {
                setSetPrimaryStatus("error");
                setError(response?.message || "Something went wrong");
            }
        } catch (err) {
            setSetPrimaryStatus("error");
            setError(err?.message || "Something went wrong");
        }
    };


    const resetStatus = () => {
        setStatus("idle");
        setAddStatus("idle");
        setRemoveStatus("idle");
        setSetPrimaryStatus("idle");
        setError("");
    };

    return {
        fetchActiveShipment,
        fetchActiveShipmentDetail,
        fetchSingleShipment,
        setPrimary,
        data,
        single,
        status,
        addStatus,
        removeStatus,
        setPrimaryStatus,
        error,
        resetStatus,
    };
};

export default useShipment;
